// extracted by mini-css-extract-plugin
export default {"footerStyle":"Footer_footerStyle__CGxO6","websiteRights":"Footer_websiteRights__qKq5Z"};